import { createStore, combineReducers } from "redux";
import InfoReducer from "./reducer";

const rootReducer = combineReducers({
	info: InfoReducer,
});

const store = createStore(rootReducer);
export default store
